var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ededed;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{fill:#f5f5f5;}.e{fill:#ff4b55;}.f{fill:#fb161b;}.g{fill:#0b3c7b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 22,
    transform: "translate(53 401)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 16,
    rx: 4,
    transform: "translate(53 404)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-53 -401)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.586,104.276H.414A.418.418,0,0,1,0,103.855V88.7a.418.418,0,0,1,.414-.421H23.586A.418.418,0,0,1,24,88.7v15.158A.418.418,0,0,1,23.586,104.276Z",
    transform: "translate(0 -88.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M24,89.507H0V88.7a.418.418,0,0,1,.414-.421H23.586A.418.418,0,0,1,24,88.7v.81Z",
    transform: "translate(0 -88.276)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 24,
    height: 1.231,
    transform: "translate(0 4.923)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 24,
    height: 1.231,
    transform: "translate(0 2.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M24,244.329H.414A.418.418,0,0,1,0,243.908v-.81H24Z",
    transform: "translate(0 -235.713)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 24,
    height: 1.231,
    transform: "translate(0 12.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M23.586,399.152H.414A.417.417,0,0,1,0,398.731v-.81H24v.81A.417.417,0,0,1,23.586,399.152Z",
    transform: "translate(0 -383.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 24,
    height: 1.231,
    transform: "translate(0 9.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M10.759,88.277H.414A.417.417,0,0,0,0,88.7v7.773a.418.418,0,0,0,.414.421H10.759a.418.418,0,0,0,.414-.421V88.7A.418.418,0,0,0,10.759,88.277Z",
    transform: "translate(0 -88.277)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.668 0.939)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.747,108l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,14.747,108Z",
    transform: "translate(-14.253 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.747,138.651l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281L14.269,139a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,14.747,138.651Z",
    transform: "translate(-14.253 -137.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.747,169.3l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,14.747,169.3Z",
    transform: "translate(-14.253 -166.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.747,199.959l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,14.747,199.959Z",
    transform: "translate(-14.253 -195.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.747,230.612l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,14.747,230.612Z",
    transform: "translate(-14.253 -224.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.54,123.026l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,38.54,123.026Z",
    transform: "translate(-36.93 -122.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.54,153.68l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,38.54,153.68Z",
    transform: "translate(-36.93 -151.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.54,184.334l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,38.54,184.334Z",
    transform: "translate(-36.93 -180.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.54,214.989l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,38.54,214.989Z",
    transform: "translate(-36.93 -209.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.333,108l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,62.333,108Z",
    transform: "translate(-59.608 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.333,138.651l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281L61.855,139a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,62.333,138.651Z",
    transform: "translate(-59.608 -137.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.333,169.3l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,62.333,169.3Z",
    transform: "translate(-59.608 -166.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.333,199.959l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,62.333,199.959Z",
    transform: "translate(-59.608 -195.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.333,230.612l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,62.333,230.612Z",
    transform: "translate(-59.608 -224.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.127,123.026l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,86.127,123.026Z",
    transform: "translate(-82.287 -122.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.127,153.68l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,86.127,153.68Z",
    transform: "translate(-82.287 -151.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.127,184.334l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,86.127,184.334Z",
    transform: "translate(-82.287 -180.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.127,214.989l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,86.127,214.989Z",
    transform: "translate(-82.287 -209.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.919,108l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,109.919,108Z",
    transform: "translate(-104.963 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.919,138.651l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,109.919,138.651Z",
    transform: "translate(-104.963 -137.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.919,169.3l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,109.919,169.3Z",
    transform: "translate(-104.963 -166.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.919,199.959l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,109.919,199.959Z",
    transform: "translate(-104.963 -195.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.919,230.612l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,109.919,230.612Z",
    transform: "translate(-104.963 -224.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M133.713,123.026l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,133.713,123.026Z",
    transform: "translate(-127.642 -122.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M133.713,153.68l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,133.713,153.68Z",
    transform: "translate(-127.642 -151.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M133.713,184.334l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,133.713,184.334Z",
    transform: "translate(-127.642 -180.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M133.713,214.989l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,133.713,214.989Z",
    transform: "translate(-127.642 -209.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M157.507,108l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,157.507,108Z",
    transform: "translate(-150.321 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M157.507,138.651l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,157.507,138.651Z",
    transform: "translate(-150.321 -137.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M157.507,169.3l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,157.507,169.3Z",
    transform: "translate(-150.321 -166.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M157.507,199.959l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,157.507,199.959Z",
    transform: "translate(-150.321 -195.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M157.507,230.612l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,157.507,230.612Z",
    transform: "translate(-150.321 -224.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M181.3,123.026l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,181.3,123.026Z",
    transform: "translate(-172.999 -122.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M181.3,153.68l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,181.3,153.68Z",
    transform: "translate(-172.999 -151.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M181.3,184.334l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,181.3,184.334Z",
    transform: "translate(-172.999 -180.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M181.3,214.989l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,181.3,214.989Z",
    transform: "translate(-172.999 -209.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.094,108l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,205.094,108Z",
    transform: "translate(-195.677 -107.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.094,138.651l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.279A.039.039,0,0,1,205.094,138.651Z",
    transform: "translate(-195.677 -137.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.094,169.3l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,205.094,169.3Z",
    transform: "translate(-195.677 -166.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.094,199.959l.092.279.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,205.094,199.959Z",
    transform: "translate(-195.677 -195.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M205.094,230.612l.092.28.29,0a.04.04,0,0,1,.023.072l-.233.175.087.281a.039.039,0,0,1-.06.044l-.236-.171-.236.171a.039.039,0,0,1-.06-.044l.087-.281-.233-.175a.04.04,0,0,1,.023-.072l.29,0,.092-.28A.039.039,0,0,1,205.094,230.612Z",
    transform: "translate(-195.677 -224.737)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnFlag);
export default __webpack_public_path__ + "static/media/en-flag.ee136459729a03abd79086ad9a2169b2.svg";
export { ForwardRef as ReactComponent };